// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2J6be","name":"ConsentHeader_name__BkAQh","birthday":"ConsentHeader_birthday__Gjlll","skeleton":"ConsentHeader_skeleton__2NGTX"};